import React from 'react'
import "./landing.min.css"
import "./responsive-landing.min.css"
import axios from 'axios'
import stripHtml from 'string-strip-html';
import {getCDNUrl, redirectToProfile} from "../commons/CommonFunctions";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ReadMoreReadLess from '../commons/ReadMoreReadLess';
import InfiniteScroll from "react-infinite-scroller";
import Loader from "react-loader-spinner";

class TestimonialItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            testimonialData: [],
            testimonialDescription: "",
            alltestimonialData: [],
            //isLandingPage: '',
            pageNo: 0,
            pageSize: 5,
            testimonialSuccess: false,
            thresholdHeight: 1000,
            nav1: null,
            nav2: null
        };
    }


    componentDidMount() {
        this.getTestimonialList(0, false);
        this.setState({
            //nav1: this.slider1,
            nav2: this.slider2
        });
    }

    getTestimonialList(page, concatWithPrevious) {
        let cancelToken;
        if (typeof cancelToken !== typeof undefined) {
            cancelToken.cancel("Cancelling the previous request")
        }
        cancelToken = axios.CancelToken.source()
        let url = `unauth/testimonial/landingPageList`;
        if(!this.props.isLandingPage) {
            url = `unauth/testimonial/list?page=${page}&size=${this.state.pageSize}`
        }
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_userServiceURL}/${url}`,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.status === 200) {
                if(this.props.isLandingPage) {
                    this.props.getTestimonialShowFlagUpdate(response.data.body.length);               
                } 
                let pageData = response.data.body;
                if (concatWithPrevious && this.state.testimonialData && this.state.testimonialData.content) {
                    pageData.content = this.state.testimonialData.content.concat(pageData.content)
                }
                this.setState({
                    testimonialData: pageData,
                    testimonialSuccess: false,
                });
            }
        }).catch((error) => {
            console.log(error);
            this.setState({
                testimonialSuccess: false
            })
        });
    }

    fetchMoreTestimonial = () => {
        if (this.state.testimonialData && this.state.testimonialData.content) {
            let pageable = this.state.testimonialData.pageable;
            this.setState({
                testimonialSuccess: true,
                pageNo: pageable.pageNumber + 1
            }, () => {
                this.getTestimonialList(this.state.pageNo, true);
            });
        }
    }

    getOptimizedCoverImage = (item) => {
        if(item && item.resizedCoverImages && item.resizedCoverImages["200x200"] != null) {
            return item.resizedCoverImages["200x200"];
        }
        return item.coverImageUrl;
    }

    getMaxChars(str, max) {
        if (str != null) {
            str = stripHtml(str);
            if (str === undefined || str === null)
                return "";

            var n = str.length;
            if (max > n) {
                return str;
            }

            var res = str.substring(0, max);
            res += "...";
            return res;
        }
    }

    redirectToDetailsPage = () =>{
        window.location.href = "/show-all/testimonial";
    }

    testimonialImageSection = (data) => {
        return (
            <div className="testi-pic">
                <img
                    src={data.coverImageUrl ? getCDNUrl(this.getOptimizedCoverImage(data)) : 
                        (data.type !== "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                    onError={(e) => { e.target.onerror = null; e.target.src = "https://cdn.dscovr.com/images/users1.png" }}
                    alt="" />   
            </div>
        )
    }

    getTestoDescriptionValueById = (content) => {
        this.setState({
            testimonialDescription: stripHtml(content)
        });
    }

    render() {
        const descSlideSettings = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 5000,
            cssEase: "ease"
        };
        const { isLandingPage } = this.props;
        const { testimonialData, thresholdHeight, testimonialSuccess, testimonialDescription } = this.state;
        return (
            <>
            {isLandingPage ? 
                <div className='row align-items-center'>
                    <div className='col-3'>
                        <Slider
                            className='testoUserSlide' 
                            asNavFor={this.state.nav1}
                            ref={slider => (this.slider2 = slider)}
                            fade= 'true'
                            arrows=''
                            infinite= 'true'
                            speed= '500'
                            slidesToShow= '1'
                            slidesToScroll= '1'>
                            {testimonialData && testimonialData.map((item)=>{
                                return (
                                    <div className="testoblockCont">
                                        <div className="testoblockAuth" onClick={(e) => {redirectToProfile(item.profileLink)}} style={{cursor: 'pointer'}}>
                                            {this.testimonialImageSection(item)}
                                            <div className="testi-profile">
                                                <h4>{item.name}</h4>
                                                <span>{item.persona}</span>
                                            </div>                                        
                                        </div>
                                    </div>
                                )                                                
                            })}
                        </Slider>
                    </div>
                    <div className='col-9'>
                        <Slider
                            {...descSlideSettings}
                            className='testoDescSlide'
                            arrows=''                     
                            asNavFor={this.state.nav2}
                            ref={slider => (this.slider1 = slider)}>
                            {testimonialData && testimonialData.map((item)=>{
                                return (
                                    <div className="testoblockCont">
                                        <div className="testoblockAuth" onClick={(e) => {this.redirectToDetailsPage()}} style={{cursor: 'pointer'}}>
                                            <p>
                                                {this.getMaxChars(item.content, 450)}
                                            </p>
                                        </div>
                                    </div>
                                )                                                
                            })}
                        </Slider>
                    </div>            
                </div>
            : <>
                <InfiniteScroll
                    loadMore={this.fetchMoreTestimonial.bind(this)}
                    hasMore={!testimonialSuccess && !testimonialData.last}
                    threshold={thresholdHeight}
                    loader={
                        <span
                            style={{ textAlign: "center", display: "block" }}
                        >
                            <div
                                style={{
                                    display: "inline-block",
                                    marginTop: "100px",
                                }}
                            >
                                <Loader
                                    type="Grid"
                                    color="#dcde63"
                                    height={60}
                                    width={60}
                                    timeout={8000}
                                />
                            </div>
                        </span>
                    }
                >
                    <div className='row'>
                        {testimonialData && testimonialData.content && testimonialData.content.map((item)=>{
                            return (
                                <div className='col-lg-6'>
                                    <div className="testoblockCont dgcard">                            
                                        <div className="testoblockAuth" onClick={(e) => {redirectToProfile(item.profileLink)}} style={{cursor: 'pointer'}}>
                                            {this.testimonialImageSection(item)}                                   
                                        </div>
                                        <div className='testiDesc'>
                                            {/* <ReadMoreReadLess description={stripHtml(item.content)}/> */}
                                            <p>{this.getMaxChars(item.content, 125)} {" "}
                                                {item.content && item.content.length > 125 && 
                                                    <a className="readMore" href='#testoDescPopup' onClick={(e)=>this.getTestoDescriptionValueById(item.content)} data-toggle="modal">read more</a>}
                                            </p>
                                            <div className="testi-profile" onClick={(e) => {redirectToProfile(item.profileLink)}} style={{cursor: 'pointer'}}>
                                                <h4>{item.name}</h4>
                                                <span>{item.persona}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )                                                
                        })}
                    </div>
                </InfiniteScroll>
                <div id={"testoDescPopup"} className="modal fade dgpopup" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="testoDescPopupBlk">
                                    <button type="button" className="close topCrossModal" data-dismiss="modal">
                                        <i className="iCross" />
                                    </button>

                                    <p dangerouslySetInnerHTML={{
                                        __html: testimonialDescription,
                                    }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
                
            </>
        )        
    }
}

export default TestimonialItem